import { MatDateFormats } from '@angular/material/core';

export function getLocaleDateFormat(locale: string): MatDateFormats { 
  
  let formats: MatDateFormats;
  
  switch (locale.toLowerCase()) {
    case ('de-CH').toLowerCase():
    case ('de-AT').toLowerCase():
    case ('de-DE').toLowerCase():
    case ('de').toLowerCase():   // Firefox spezifisch
      formats = {
        parse: { 
          dateInput: 'DD.MM.YYYY'
        },
        display: {
          dateInput: 'DD.MM.YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY'
        }
      };
      break;
    case ('en-US').toLowerCase():
    case ('en').toLowerCase(): // Firefox spezifisch
      formats = {
        parse: {
          dateInput: 'MM/DD/YYYY'
        },
        display: {
          dateInput: 'MM/DD/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY'
        }
      };
      break;
    // Fügen Sie hier weitere Locale-spezifische Formate hinzu
    default:
      formats = {
        parse: {
          dateInput: 'YYYY-MM-DD'
        },
        display: {
          dateInput: 'YYYY-MM-DD',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY'
        }
      };
      break;
  }
  //console.log('Aktuelle Formate:', formats);
  return formats;
}